import { Component, h, Element, Prop, Host } from '@stencil/core';
import {
  TBtnGroupDirection,
  TBtnGroupGutterSize,
  TBtnGroupWrap,
  TBtnGroupAlignment,
  TBtnGroupJustifyContent,
} from './btn-group-utils';
import { injectCSS } from '../../utils';
import { createStyles } from './btn-group-styles';

@Component({
  tag: 'dc-ui-btn-group',
  shadow: true,
})
export class DcUiBtnGroup {
  @Element() el: HTMLElement;
  @Prop() direction: TBtnGroupDirection = 'row';
  @Prop() gutterSize: TBtnGroupGutterSize = 16;
  @Prop() wrap: TBtnGroupWrap = 'wrap';
  @Prop() align: TBtnGroupAlignment = 'start';
  @Prop() justify: TBtnGroupJustifyContent = 'start';

  render() {
    injectCSS(
      this.el,
      createStyles,
      this.direction,
      this.gutterSize,
      this.wrap,
      this.align,
      this.justify
    );

    return (
      <Host>
        <slot />
      </Host>
    );
  }
}
